import {SOPutInterphace} from '../../core/interphace/so-put-interphace';
import {InterphaceCore} from './interphace.core';
import {SOGetInterphace} from '../../core/interphace/so-get-interphace';
import {FormField, SelectionOption} from 'lionheartland';
import {putInterphaceFormFieldOptions} from './put-interphace-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {EntityCore} from '../entity/entity.core';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutInterphace extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putInterphaceFormFieldOptions);

  RequestClass = SOPutInterphace

  constructor(
    public entityCore: InterphaceCore
  ) {
    super();
    if (putInterphaceFormFieldOptions.entity) {
      putInterphaceFormFieldOptions.entity.makeCore = true;
    }
    if (putInterphaceFormFieldOptions.project) {
      putInterphaceFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('interphaceType'),
      this.getFormValueFromIdentifier(
        'entity',
        SOGetEntity,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}